import { render, staticRenderFns } from "./UserSimpleAuditLog.vue?vue&type=template&id=60083cf8&scoped=true&"
import script from "./UserSimpleAuditLog.vue?vue&type=script&lang=ts&"
export * from "./UserSimpleAuditLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60083cf8",
  null
  
)

export default component.exports